import React from 'react';
import Typography from '@material-ui/core/Typography';
import {withPageLayout, WithPageLayoutProps} from '../../hocs';
import {Button} from '../../components';
import {useLocation} from 'react-router-dom';
import {useGetMessages} from '../../hooks';
import useStyles from './ErrorView.styles';
import {getMessage} from 'epic-diesel-common';

// make sure status is supported in i18n doc
const SUPPORTED_ERROR_CODES = [404, 500];

export interface ErrorViewProps extends WithPageLayoutProps {
    status: number;
}

interface LocationState {
    errorCode?: string;
    args?: any[];
}

const ErrorView: React.FC<ErrorViewProps> = ({messages: i18nMap, status = 500}) => {
    const styles = useStyles();
    const location = useLocation<LocationState>();
    const messages = useGetMessages(() => {
        const messageCode = SUPPORTED_ERROR_CODES.includes(status) ? status : 500;
        return {
            errorMessage: `affiliate.main.error.${messageCode}.message`,
            backHome: 'affiliate.main.error.btn.back'
        };
    }, [status]);

    return (
        <div className={styles.root}>
            <span className={styles[`charactor${status}`]} />
            <h1 className={styles.statusText}>{status}</h1>

            <div className={styles.container}>
                <Typography className={styles.message} variant="h2">
                    {messages.errorMessage}
                </Typography>

                {location.state && (
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: getMessage(
                                i18nMap,
                                location.state.errorCode,
                                location.state.args
                            )
                        }}
                    />
                )}

                <Button className={styles.backButton} to="/" size="large">
                    {messages.backHome}
                </Button>
            </div>
        </div>
    );
};

export default withPageLayout(ErrorView, {skipLoginCheck: true, skipAffiliateStatusCheck: true});
